<template>
    <div class="flex flex-col h-screen bg-gray-800 w-64 border-r-2 border-blue-700 text-white">
        <div class="p-3 cursor-pointer" @click="$router.push({ name: 'DashboardView' })">
            <img src="@/assets/Clubs Casino_Poker Blue_Snow White.svg" alt="Clubs Poker Logo"
                class="w-full h-auto object-contain" />
        </div>

        <div v-for="module in top_modules" :key="module.name" class="p-3">
            <div class="flex justify-between items-center cursor-pointer font-bold" @click="toggle_module(module.name)">
                <div class="flex items-center">
                    <i :class="module.icon" class="mr-2"></i>
                    <span>{{ module.name }}</span>
                </div>
                <i class="bi"
                    :class="module.open ? 'bi-chevron-right transform rotate-90 transition-transform' : 'bi-chevron-right transition-transform'"></i>
            </div>
            <transition name="slide">
                <ul v-if="module.open" class="mt-2 ml-3 space-y-2 bg-gray-700 p-2 rounded">
                    <li v-for="(link, index) in module.links" :key="index">
                        <router-link :to="{ name: link.component }"
                            class="block hover:bg-blue-700 hover:text-orange-500 p-2 rounded">
                            {{ link.name }}
                        </router-link>
                    </li>
                </ul>
            </transition>
        </div>

        <div v-for="module in bottom_modules" :key="module.name" class="mt-auto p-3">
            <div class="flex items-center">
                <i :class="module.icon" class="mr-2"></i>
                <router-link :to="{ name: module.component }" class="block hover:text-orange-500">
                    {{ module.name }}
                </router-link>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'LeftNav',
    data() {
        return {
            top_modules: [
                {
                    name: 'Statistics',
                    icon: 'bi bi-bar-chart',
                    open: false,
                    links: [
                        { name: 'Overview', component: 'DashboardView' },
                        { name: 'KPIs', component: 'DetailedKeyPerformanceView' },
                        { name: 'Select KPIs by Code', component: 'KeyPerformanceView' },
                        { name: 'All Codes Details', component: 'PromoCodeView' }
                    ]
                },
            ],
            bottom_modules: [
                {
                    name: 'Logout',
                    icon: 'bi bi-box-arrow-right',
                    component: 'logout'
                }
            ]
        }
    },
    methods: {
        toggle_module(module_name) {
            this.top_modules = this.top_modules.map(module => {
                if (module.name === module_name) {
                    module.open = !module.open
                } else {
                    module.open = false
                }
                return module
            })
        }
    }
}
</script>

<style scoped>
.slide-enter-active,
.slide-leave-active {
    transition: max-height 0.4s ease-out;
}

.slide-enter,
.slide-leave-to {
    max-height: 0;
    overflow: hidden;
}
</style>